import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfigService } from '../services/config.service';
import { Util } from '../util';
import { ActionType } from '../models/action';
import { LoginDialogComponent } from '../login/components/login-dialog/login-dialog.component';

@Injectable()
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/']);
    if (this.configService.get().customLoginUrl) {
      this.authService.getExternalLoginUrl(this.configService.get().customLoginUrl).subscribe((url) => {
        window.location.href = url;
      });
    } else {
      this.dialog
        .open(LoginDialogComponent)
        .afterClosed()
        .subscribe((value) => {
          if (value) {
            return this.router.navigateByUrl(state.url).then(() => location.reload());
          } else {
            const action = Util.getAction();
            if (action) {
              Util.setAction({
                ...action,
                type: ActionType.NONE,
              });
            } else {
              Util.removeAction();
            }
          }
        });

      return false;
    }
  }
}
